import { render, staticRenderFns } from "./PostComments.vue?vue&type=template&id=21c61ba4&scoped=true&"
import script from "./PostComments.vue?vue&type=script&lang=js&"
export * from "./PostComments.vue?vue&type=script&lang=js&"
import style0 from "./PostComments.vue?vue&type=style&index=0&id=21c61ba4&lang=scss&scoped=true&"
import style1 from "./PostComments.vue?vue&type=style&index=1&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "21c61ba4",
  null
  
)

export default component.exports